import { createTheme } from '@mui/material/styles'

export const defaultPickerSlotProps = {
    popper: {
        placement: 'auto',
        popperOptions: {
            modifiers: [
                {
                    name: 'flip',
                    enabled: true,
                    options: {
                        fallbackPlacements: [
                            'top-start',
                            'bottom-start',
                            'top',
                            'bottom',
                        ],
                    },
                },
                {
                    name: 'preventOverflow',
                    enabled: true,
                    options: {
                        padding: 16,
                        boundary: 'viewport',
                    },
                },
            ],
        },
    },
    desktopPaper: {
        sx: {
            maxHeight: 'calc(100vh - 40px)',
            overflowY: 'auto',
        },
    },
}

export const muiTheme = createTheme({
    components: {
        MuiDatePicker: {
            defaultProps: {
                slotProps: defaultPickerSlotProps,
            },
        },
        MuiDateTimePicker: {
            defaultProps: {
                slotProps: defaultPickerSlotProps,
            },
        },
        MuiTimePicker: {
            defaultProps: {
                slotProps: defaultPickerSlotProps,
            },
        },
        MuiDesktopDatePicker: {
            defaultProps: {
                slotProps: defaultPickerSlotProps,
            },
        },
        MuiDesktopDateTimePicker: {
            defaultProps: {
                slotProps: defaultPickerSlotProps,
            },
        },
        MuiDesktopTimePicker: {
            defaultProps: {
                slotProps: defaultPickerSlotProps,
            },
        },
        MuiMobileDatePicker: {
            defaultProps: {
                slotProps: defaultPickerSlotProps,
            },
        },
        MuiMobileDateTimePicker: {
            defaultProps: {
                slotProps: defaultPickerSlotProps,
            },
        },
        MuiMobileTimePicker: {
            defaultProps: {
                slotProps: defaultPickerSlotProps,
            },
        },
    },
})

export default muiTheme
